export type OursDeviceId = {
  ours_device_id: string;
};

export type WithOursDeviceId = Partial<OursDeviceId>;

export const OURS_DEVICE_ID_KEY = 'ours_device_id';
